var BrowserFS = require('browserfs');module.exports=BrowserFS.BFSRequire('buffer').Buffer;


/*****************
 ** WEBPACK FOOTER
 ** ./shims/BFSBuffer.js
 ** module id = 7
 ** module chunks = 0
 **/